"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaTgtJigyo = void 0;
var _TitlePaper = _interopRequireDefault(require("01_core/components/layout/TitlePaper"));
var _react = _interopRequireDefault(require("react"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _ListItem = _interopRequireDefault(require("@mui/material/ListItem"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査対象事業
 */
const KansaTgtJigyo = props => {
  const {
    kansaTgtJigyoNm,
    hakkenjikoList
  } = props;
  const PrimaryText = (0, _styles.styled)('span')(_ref => {
    let {
      theme
    } = _ref;
    return {
      fontSize: theme.typography.fontSize
    };
  });
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_TitlePaper.default, {
    title: kansaTgtJigyoNm,
    size: {
      xs: 12
    }
  }), hakkenjikoList.map(item => {
    return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
      divider: true
    }, /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
      primary: /*#__PURE__*/_react.default.createElement(PrimaryText, null, item)
    }));
  })));
};
exports.KansaTgtJigyo = KansaTgtJigyo;
var _default = exports.default = KansaTgtJigyo;